import {Injectable} from '@angular/core'
import {
  ActivatedRouteSnapshot,
  Data,
  NavigationEnd,
  Router,
} from '@angular/router'
import {Breadcrumb} from './breadcrumbs.component'
import {filter} from 'rxjs/operators'
import {BehaviorSubject} from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([])
  readonly breadcrumbs$ = this._breadcrumbs$.asObservable()
  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const root = this.router.routerState.snapshot.root
        const breadcrumbs: Breadcrumb[] = []
        this.addBreadcrumb(root, [], breadcrumbs)
        this._breadcrumbs$.next(breadcrumbs)
      })
  }

  private addBreadcrumb(
    route: ActivatedRouteSnapshot,
    parentUrl: string[],
    breadcrumbs: Breadcrumb[],
  ) {
    if (route) {
      const routeUrl = parentUrl.concat(route.url.map((url) => url.path))
      if (route.data.breadcrumb) {
        const breadcrumb = {
          label: this.getLabel(route.data),
          url: '/' + routeUrl.join('/'),
        }
        breadcrumbs.push(breadcrumb)
      }
      this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs)
    }
  }

  addBreadcrumbs(routes) {
    this._breadcrumbs$.next(routes)
  }

  private getLabel(data: Data) {
    // The breadcrumb can be defined as a static string or as a function to construct the breadcrumb element out of the route data
    return typeof data.breadcrumb === 'function'
      ? data.breadcrumb(data)
      : data.breadcrumb
  }
}
